import { Config } from 'common/config'
import { EColors } from 'common/styles'
import { Styled } from 'components/Styled'
import { GeneralMenu } from 'modules/GeneralMenu'
import { Fade, Slide } from 'react-awesome-reveal'
import { Trans, useTranslation } from 'react-i18next'
import { Component } from './components'
import {
  Container,
  ContentWrapper,
  KitchenAboutImage,
  InfoWrapper,
  LeftContainer,
} from './styled'

export const OurKitchen = () => {
  const { t } = useTranslation()

  return (
    <>
      <Container id={Config.Section.ourKitchen}>
        <ContentWrapper>
          <Fade triggerOnce direction="up" delay={200} cascade>
            <Styled.H2 color={EColors.primary_500}>
              {t('our.kitchen')}
            </Styled.H2>

            <InfoWrapper>
              {/* Left */}
              <LeftContainer>
                <KitchenAboutImage />

                <Trans
                  i18nKey={'our.kitchen.info'}
                  components={{ p: <Styled.PBody1 /> }}
                />

                <GeneralMenu hideDelivery hideOurMenu />
              </LeftContainer>

              <Component.Menu />
            </InfoWrapper>
          </Fade>
        </ContentWrapper>
      </Container>
    </>
  )
}
